import {mapState} from 'vuex'
import config from '@/config'
import moment from 'moment'
import { isUsaSummer } from "@/utils/index"
export default {
  props: {
    showInfo: {
      type: Boolean,
      default: false
    },
    showBack: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      zone: ''
    }
  },
  computed: {
    ...mapState(['status', 'code', 'market', 'stockname', 'dyna', 'region', 'symbol']),
    price() {
      let p = (this.dyna && this.dyna.LastPrice) || 0
      return this.isUsa() ? p.toFixed(3) : p.toFixed(2)
    },
    updown() {
      let p = (this.dyna && this.dyna.Updown) || 0
      return (p * 100).toFixed(2) + '%'
    },
    showTime() {
      return moment(this.getZoomTime(this.dyna.Time)).format('MM-DD HH:mm:ss')
    }
  },
  filters: {
    getStatus (type, region) {
      return config.marketStatus[region === 'CN' ? 'CN' : 'GMG'][type]
    },
    subStr (val) {
      if(val && val.length > 10) return `${val.substring(0, 10)}...`
      return val
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        path: `/${this.market}/${this.symbol}.html`,
      })
    },
    getZoomTime (t) {
      if(this.region === 'USA') {
        // 夏令时\冬令时
        t = isUsaSummer ? (t + 12 * 3600) : (t + 13 * 3600)
      }
      return t * 1000
    },
    isUsa() {
      return this.region === 'USA'
    },
    getCode (val) {
      return this.region === 'HK' && /\d+/.test(val) ? '0' + val : val
    }
  }
}